(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/dialogs/confirm-payment.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/dialogs/confirm-payment.js');
"use strict";


const getTitle = _ref => {
  let products = _ref.products,
    price = _ref.price,
    payAfterDeposit = _ref.payAfterDeposit;
  const numberOfTickets = products.reduce((a, v) => a + v.count, 0);
  const product = products.length > 1 || products.some(product => product.count > 1) ? "".concat(numberOfTickets, " lotter") : "en ".concat(products[0].name);
  return "".concat(payAfterDeposit ? 'Din insättning är klar.<br>' : '', "Vill du betala och ge bort ").concat(product, " f\xF6r ").concat(price, " kr?");
};
const confirmPayment = _ref2 => {
  let accountBalance = _ref2.accountBalance,
    products = _ref2.products,
    price = _ref2.price,
    payAfterDeposit = _ref2.payAfterDeposit,
    next = _ref2.next,
    cancel = _ref2.cancel;
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'games',
    title: getTitle({
      products,
      price,
      payAfterDeposit
    }),
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: 'Köpet går inte att annullera',
      align: svs.components.dialog.message.align.CENTER
    }, {
      type: svs.components.dialog.message.TEXT,
      text: "Ditt saldo: ".concat(svs.utils.format.Currency(accountBalance), " kr"),
      align: svs.components.dialog.message.align.CENTER
    }],
    actions: [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        svs.utils.paramHandler.remove({
          key: 'ispay'
        });
        cancel();
        dialog.close();
      }
    }, {
      title: "Betala ".concat(price, " kr"),
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
setGlobal('svs.tickets_giftshop.dialogs.confirmPayment', confirmPayment);

 })(window);